export default __webpack_public_path__ + "static/media/Feature2(3).f110e4e9.png";